<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Multiselect from 'vue-multiselect'
import ProductService from '@/services/product'
import { VMoney } from 'v-money'

export default {
  page: {
    title: "Produto",
  },
  components: { Layout, PageHeader, Multiselect },
  directives: { money: VMoney },
  data() {
    return {
      title: "Produto",
      product: { original_price: 0, promotional_price: 0, cash_price: 0, term_price: 0, dimensions: {}, color: { name: '' } },
      categories: [],
      brands: [],
      features: [],
      tags: [],
      complements: [],
      productsToVariation: [],
      isLoadingProducts: false,
      imageToRemove: '',
      variationToRemoveIndex: '',
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailHeight: 100,
        addRemoveLinks: true,
        destroyDropzone: true,
        createImageThumbnails: false
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false,
      }
    }
  },
  methods: {
    saveProduct() {
      // if (!this.product.code && !this.product.barcode && !this.product.sku) {
      //   return this.$toast.info('Informe pelo menos um código para o produto');
      // }

      if (!this.product.description) {
        return this.$toast.info('Informe a descrição do produto');
      }

      let loader = this.$loading.show();

      const data = {
        _id: this.product._id,
        sku: this.product.sku,
        barcode: this.product.barcode,
        code: this.product.code,
        description: this.product.description,
        price: this.product.original_price ? this.product.original_price.toString().replace('.', '').replace(',', '.') : null,
        promotional_price: this.product.promotional_price ? this.product.promotional_price.toString().replace('.', '').replace(',', '.') : null,
        cash_price: this.product.cash_price ? this.product.cash_price.toString().replace('.', '').replace(',', '.') : null,
        term_price: this.product.term_price ? this.product.term_price.toString().replace('.', '').replace(',', '.') : null,
        stock: this.product.stock ? this.product.stock.toString().replace('.', '').replace(',', '.') : null,
        categories_tags: this.product.categories_tags,
        details: this.product.details,
        // a API normaliza o texto (name/slug/source); enviar vazio limpa a cor
        color: (this.product.color && this.product.color.name)
          ? { name: this.product.color.name, hex: this.product.color.hex || null }
          : null,
        active: this.product.active,
      }

      ProductService.saveProduct(data).then(res => {
        if (res.data._id) {
          this.product._id = res.data._id;
        }

        this.$forceUpdate();

        loader.hide();

        this.$toast.open('Dados atualizados')
      }).catch((err) => {
        this.$toast.error(err);
        loader.hide();
      })
    },
    handleFilesUpload(){      
      const files = this.$refs.file.files;

      for( var i = 0; i < files.length; i++ ) {
        const imageIndex = this.product.images.length;

        this.product.images.push('temp');

        let file = files[i];
        
        let formData = new FormData();
        formData.append('file', file);

        ProductService.uploadImage(this.product._id, formData).then(res => {
          this.product.images[imageIndex] = {
            _id: res.data._id,
            url: res.data.url,
          };

          this.$forceUpdate();
          this.$toast.open('Imagem adicionada com sucesso');
        }).catch(() => {
          this.product.images.splice(imageIndex, 1);
          this.$forceUpdate();
        })
      }      
    },
    removeImage() {
      this.$bvModal.hide('modal-remove-image');

      ProductService.removeImage(this.product._id, this.imageToRemove).then(() => {
        this.loadProduct();
        this.$toast.open('Imagem removida com sucesso');
      }).catch(() => {
        this.$toast.error('Ocorreu um erro ao remover a imagem');
      })
    },
    addDetail() {
      this.product.details.push({
        title: '',
        description: '',
      })
    },
    removeDetail(index) {
      this.product.details.splice(index, 1);
    },
    async loadProduct() {
      const result = await ProductService.getProduct(this.product._id);
      this.product = result.data.data;

      this.formatProduct();
    },
    formatProduct() {
      // Com preço à vista/a prazo ligado, a API devolve original_price = à vista e manda o
      // preço cheio (campo `price` do cadastro) em list_price. Sem isso o campo "Preço"
      // mostrava o à vista e, ao salvar, gravava o à vista por cima do preço cheio.
      if (this.product.list_price != null) {
        this.product.original_price = this.product.list_price;
      }
      this.product.original_price = (this.product.original_price || 0).toFixed(2).replace('.', ',');
      this.product.promotional_price = (this.product.promotional_price || 0).toFixed(2).replace('.', ',');
      this.product.cash_price = (this.product.cash_price || 0).toFixed(2).replace('.', ',');
      this.product.term_price = (this.product.term_price || 0).toFixed(2).replace('.', ',');

      if (this.product.details.length === 0) {
        this.product.details = [{ title: '', description: '' }];
      }

      if (!this.product.dimensions) {
        this.product.dimensions = {};
      }

      if (!this.product.color) {
        this.product.color = { name: '' };
      } else if (this.product.color.name === undefined) {
        // produto salvo antes do campo existir: torna a chave reativa
        this.$set(this.product.color, 'name', '');
      }

      if (this.product.categories_tags) {
        const categories = this.categories.filter(item => {
          return this.product.categories_tags.includes(item._id);
        })

        this.product.categories_tags = categories;
      }

      if (this.product.variations) {
        this.product.variations.forEach(variation => {
          variation.price = variation.price.toFixed(2).replace('.', ',');
        });
      }

      if (this.product.main_product) {
        this.findProductsToVariationConfig('', this.product.main_product)
      }

      // if (this.product.quantity_limit_per_sale) {
      //   this.product.quantity_limit_per_sale = this.product.quantity_limit_per_sale.toFixed(2).replace('.', ',');
      // }

      if (this.product.unit_sale) {
        this.product.unit_sale = this.product.unit_sale.toFixed(2).replace('.', ',');
      }

      if (this.product.fractionated_unit) {
        this.product.fractionated_unit = this.product.fractionated_unit.toFixed(2).replace('.', ',');
      }

      if (this.product.dimensions) {
        if (this.product.dimensions.weight) {
          this.product.dimensions.weight = this.product.dimensions.weight.toFixed(2).replace('.', ',');
        }

        if (this.product.dimensions.length) {
          this.product.dimensions.length = this.product.dimensions.length.toFixed(2).replace('.', ',');
        }

        if (this.product.dimensions.width) {
          this.product.dimensions.width = this.product.dimensions.width.toFixed(2).replace('.', ',');
        }

        if (this.product.dimensions.height) {
          this.product.dimensions.height = this.product.dimensions.height.toFixed(2).replace('.', ',');
        }
      }
    },
    saveVariations() {
      let loader = this.$loading.show();

      const data = {
        _id: this.product._id,
        need_select_variation: this.product.need_select_variation,
        variation_by_association: this.product.variation_by_association,
        variation_description: this.product.variation_description,
        variation_title: this.product.variation_title,
        complements: (this.product.complements || []).map(item => item._id)
      };

      if (this.product.need_select_variation) {
        const variations = (this.product.variations || []).map(item => {
          return {
            ...item,
            price: item.price ? item.price.toString().replace('.', '').replace(',', '.') : null,
            stock: item.stock ? item.stock.toString().replace('.', '').replace(',', '.') : null,
          }
        })

        data.variations = variations;
      }

      data.fractionated_variation = this.product.fractionated_variation;
      data.fractionated_as_box = this.product.fractionated_as_box;
      
      if (data.fractionated_variation) {
        data.fractionated_unit = this.product.fractionated_unit ? this.product.fractionated_unit.replace('.', '').replace(',', '.') : null;
      } else {
        data.fractionated_unit = null;
      }

      if (this.product.variation_by_association) {
        data.is_main_variation = this.product.is_main_variation;
        data.main_product = this.product.main_product;
      }

      ProductService.saveProduct(data).then(() => {
        loader.hide();

        this.$toast.open('Dados atualizados')
        this.loadProduct();
      }).catch((err) => {
        this.$toast.error(err);
        loader.hide();
      })
    },
    addVariation() {
      if (!this.product.variations) {
        this.product.variations = [];
      }

      this.product.variations.push({
        new: true,
        sku: '',
        variation_description: '',
        price: this.product.original_price,
        stock: ''
      })

      this.$forceUpdate();
    },
    removeVariation() {
      const index = this.product.variations.length - 1;

      if (this.product.variations[index].new) {
        this.product.variations.splice(index, 1);
        this.$forceUpdate();
      } else {
        this.variationToRemoveIndex = index;
        this.$bvModal.show('modal-remove-variation');
      }
    },
    removeProductVariation() {
      this.$bvModal.hide('modal-remove-variation');
      let loader = this.$loading.show();

      ProductService.removeProduct(this.product.variations[this.variationToRemoveIndex]._id).then(() => {
        this.$toast.open('Variação removida');
        this.loadProduct();

        loader.hide();
      }).catch(() => {
        this.$toast.error('Ocorreu um erro ao excluir a variação');
        loader.hide();
      })
    },
    saveDimensions() {
      let loader = this.$loading.show();

      const dimensions = {
        weight: this.product.dimensions.weight ? this.product.dimensions.weight.toString().replace('.', '').replace(',', '.') : null,
        width: this.product.dimensions.width ? this.product.dimensions.width.toString().replace('.', '').replace(',', '.') : null,
        length: this.product.dimensions.length ? this.product.dimensions.length.toString().replace('.', '').replace(',', '.') : null,
        height: this.product.dimensions.height ? this.product.dimensions.height.toString().replace('.', '').replace(',', '.') : null,
      }

      const data = {
        _id: this.product._id,
        quantity_limit_per_sale: this.product.quantity_limit_per_sale ? this.product.quantity_limit_per_sale.toString().replace('.', '').replace(',', '.') : null,
        unit_sale: this.product.unit_sale ? this.product.unit_sale.toString().replace('.', '').replace(',', '.') : null,
        dimensions,
      }

      ProductService.saveProduct(data).then(() => {
        loader.hide();

        this.$toast.open('Dados atualizados')
        this.loadProduct();
      }).catch((err) => {
        this.$toast.error(err);
        loader.hide();
      })
    },
    saveSettings() {
      let loader = this.$loading.show();

      const data = {
        _id: this.product._id,
        check_stock: this.product.check_stock,
        use_as_complement: this.product.use_as_complement,
        release: this.product.release,
        featured: this.product.featured,
      }

      ProductService.saveProduct(data).then(() => {
        loader.hide();

        this.$toast.open('Dados atualizados')
        this.loadProduct();
      }).catch((err) => {
        this.$toast.error(err);
        loader.hide();
      })
    },
    findProductsToVariationConfig(term, productId) {
      this.isLoadingProducts = true;

      ProductService.getAllProducts(1, term).then(res => {
        this.isLoadingProducts = false;

        this.productsToVariation = res.data.data.filter(item => {
          return item._id !== this.product._id;
        });

        if (productId) {
          const product = this.productsToVariation.find(item => {
            return item._id === productId;
          })

          this.product.main_product = product;
        }
      }).catch(() => {
        this.isLoadingProducts = false;
      })
    }
  },
  mounted() {
    let loader = this.$loading.show();

    const requests = [
      ProductService.getCategories(),
      ProductService.getAllComplementsGroups(),
    ]

    const productId = this.$route.params.id;
    if (productId) {
      requests.push(ProductService.getProduct(productId));
    }

    Promise.all(requests).then(res => {
      this.title = 'Editando Produto';

      loader.hide();

      this.categories = res[0].data.list;
      this.complements = res[1].data.data;

      if (productId) {
        this.product = res[2].data.data;

        this.formatProduct();
      } else {
        this.title = 'Novo Produto'
        this.product = {
          new: true,
          active: false,
          details: [{ title: 'Detalhes', description: '' }],
          dimensions: {},
          color: { name: '' },
          images: [],
        }
      }
    }).catch(() => {
      loader.hide();
      this.$toast.error('Erro ao carregar os dados do produto');
    })
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title"/>
    <!-- <div class="row" v-if="loading">
      <div class="col-12">
        <div class="text-center my-3">
          <a href="javascript:void(0);" class="text-primary">
            <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
          </a>
        </div>
      </div>
    </div> -->

    <div class="checkout-tabs" v-if="product">
      <b-tabs pills vertical nav-class="p-0" nav-wrapper-class="col-lg-2 w-100">
        <b-tab active>
          <template v-slot:title>
            <i class="bx bx-package d-block check-nav-icon mt-4 mb-2"></i>
            <p class="font-weight-bold mb-4">Dados Principais</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <!-- <h4 class="card-title">Dados do Produto</h4> -->
                <!-- <p class="card-title-desc">Preencha os dados</p> -->
                <form>
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="form-group">
                        <div class="custom-control custom-checkbox mb-3">
                          <input type="checkbox" class="custom-control-input" id="customCheck1" v-model="product.active" />
                          <label class="custom-control-label card-title" for="customCheck1">Produto ativo</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div class="row">
                    <div class="col-sm-4">
                      <div class="form-group">
                        <label for="productSku">Código SKU</label>
                        <input id="productSku" name="productSku" type="text" class="form-control" v-model="product.sku" />
                      </div>
                    </div>

                    <div class="col-sm-4">
                      <div class="form-group">
                        <label for="productBarcode">Cód. de Barras/EAN</label>
                        <input id="productBarcode" name="productBarcode" type="text" class="form-control" v-model="product.barcode" />
                      </div>
                    </div>

                    <div class="col-sm-4">
                      <div class="form-group">
                        <label for="productCode">Código Interno</label>
                        <input id="productCode" name="productCode" type="text" class="form-control" v-model="product.code" />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-sm-4">
                      <div class="form-group">
                        <label for="productDescription">Descrição do Produto</label>
                        <input id="productDescription" name="productDescription" type="text" class="form-control" v-model="product.description" />
                      </div>
                    </div>

                    <div class="col-sm-2">
                      <div class="form-group">
                        <label for="productColor">Cor</label>
                        <input id="productColor" name="productColor" type="text" class="form-control" placeholder="Ex.: Azul Marinho" v-model="product.color.name" />
                      </div>
                    </div>

                    <div class="col-sm-2">
                      <div class="form-group">
                        <label for="productStock">Estoque</label>

                        <input
                          id="productStock"
                          name="productStock"
                          type="tel"
                          class="form-control"
                          v-model="product.stock"
                        />
                      </div>
                    </div>

                    <div class="col-sm-2">
                      <div class="form-group">
                        <label for="productPrice">Preço</label>

                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span id="validationTooltipUsernamePrepend" class="input-group-text">R$</span>
                          </div>
                          <input
                            id="productPrice"
                            name="productPrice"
                            class="form-control"
                            v-model="product.original_price"
                            v-money="money"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-2">
                      <div class="form-group">
                        <label for="productPromotionalPrice">Promoção</label>

                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span id="validationTooltipUsernamePrepend" class="input-group-text">R$</span>
                          </div>
                          <input
                            id="productPromotionalPrice"
                            name="productPromotionalPrice"
                            class="form-control"
                            v-model="product.promotional_price"
                            v-money="money"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-2">
                      <div class="form-group">
                        <label for="productCashPrice">Preço à vista</label>

                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">R$</span>
                          </div>
                          <input
                            id="productCashPrice"
                            name="productCashPrice"
                            class="form-control"
                            v-model="product.cash_price"
                            v-money="money"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-2">
                      <div class="form-group">
                        <label for="productTermPrice">Preço a prazo</label>

                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">R$</span>
                          </div>
                          <input
                            id="productTermPrice"
                            name="productTermPrice"
                            class="form-control"
                            v-model="product.term_price"
                            v-money="money"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-sm-12">
                      <div class="form-group">
                        <label class="control-label">Categorias</label>
                        <multiselect
                          v-model="product.categories_tags"
                          :options="categories"
                          :multiple="true"
                          placeholder="Selecione várias opções"
                          label="full_description"
                          track-by="_id"
                          selectLabel="Enter para selecionar"
                          selectedLabel="Selecionado"
                          deselectLabel="Enter para remover"
                        ></multiselect>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-sm-12">
                      <div class="form-group">
                        <label>Dados Complementares</label>

                        <div>
                          <div v-for="(detail, index) in product.details" :key="index" class="row">
                            <div class="form-group col-lg-3">
                              <input id="productDetailTitle" name="productDetailTitle" placeholder="Informe o título (Ex.: Detalhes)" type="text" class="form-control" v-model="detail.title" />
                              <div class="custom-control custom-checkbox mt-2">
                                <input type="checkbox" class="custom-control-input" :id="'detailHtml' + index" v-model="detail.isHtml" />
                                <label class="custom-control-label font-size-12" :for="'detailHtml' + index">Descrição em HTML</label>
                              </div>
                            </div>

                            <div class="form-group col-lg-9">
                              <textarea id="productDetailDescription" class="form-control" rows="6" v-model="detail.description" placeholder="Informe aqui o detalhamento do produto"></textarea>
                              <div class="text-right mt-3">
                                <b-button pill variant="link" @click="removeDetail(index)" v-if="index > 0">Remover</b-button>
                                <b-button pill variant="outline-primary" @click="addDetail" v-if="index + 1 === product.details.length">+ Detalhes</b-button>
                              </div>
                            </div>
                          </div>

                          <!-- <b-button pill variant="primary" @click="addDetail">+ Detalhes</b-button> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div class="row mt-4 align-items-center">
              <div class="col-sm-6">
                <router-link
                  tag="a"
                  to="/products"
                  class="btn text-muted d-none d-sm-inline-block btn-link"
                >
                  <i class="mdi mdi-arrow-left mr-1"></i> Voltar para lista de produtos
                </router-link>
              </div>

              <div class="col-sm-6">
                <div class="text-sm-right">
                  <!-- <b-spinner class="m-2" variant="primary" role="status" v-if="loading"></b-spinner> -->
                  <button type="button" class="btn btn-primary btn-rounded mb-2 mr-2" @click="saveProduct">
                    <i class="mdi mdi-check mr-1"></i> Salvar Dados Principais
                  </button>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>
        <b-tab :disabled="(!product._id) ? true : false">
          <template v-slot:title>
            <i class="bx bx-images d-block check-nav-icon mt-4 mb-2"></i>
            <p class="font-weight-bold mb-4">Imagens</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <h4 class="card-title mb-3">Imagens do Produto</h4>
                <div class="images">                 
                  <div v-for="image in product.images" :key="image._id" class="image">
                    <div v-if="image !== 'temp' ? true : false" class="image-group">
                      <img :src="image.url"/>
                      <b-button pill variant="link" v-b-modal.modal-remove-image @click="imageToRemove = (image._id || image.integration_code)">Remover</b-button>
                    </div>

                    <div class="new-image" v-else>
                      <!-- <i class="bx bx-image-add"></i>
                      <p>Clique para adicionar uma nova imagem</p> -->
                      <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                    </div>
                  </div>                  
                  <input type="file" multiple accept="image/*" name="file" ref="file" v-on:change="handleFilesUpload" />
                </div>                
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-6">
                <router-link
                  tag="a"
                  to="/products"
                  class="btn text-muted d-none d-sm-inline-block btn-link"
                >
                  <i class="mdi mdi-arrow-left mr-1"></i> Voltar para lista de produtos
                </router-link>
              </div>
              <!-- end col -->
              <div class="col-sm-6">
                <div class="text-sm-right">
                  <!-- <router-link tag="a" to="/ecommerce/checkout" class="btn btn-success">
                    Salvar e ir para Imagens
                  </router-link> -->

                  <button type="button" class="btn btn-primary btn-rounded mb-2 mr-2" @click="$refs.file.click()">
                    <i class="mdi mdi-plus mr-1"></i> Adicionar Imagens
                  </button>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>

        <!-- <b-tab :disabled="(product.new && !product._id) ? true : false">
          <template v-slot:title>
            <i class="bx bx-purchase-tag d-block check-nav-icon mt-4 mb-2"></i>
            <p class="font-weight-bold mb-4">Preços</p>
          </template>
          <b-card-text>
          </b-card-text>
        </b-tab> -->

        <b-tab :disabled="(!product._id) ? true : false">
          <template v-slot:title>
            <i class="bx bx-package d-block check-nav-icon mt-4 mb-2"></i>
            <p class="font-weight-bold mb-4">Unidade e Tamanho</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">Dimensões</h4>
                <p class="card-title-desc">As dimensões do produto são importantes para o cálculo do frete nas integrações com Correios e transportadora.</p>
                <form>
                  <div class="row">
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label for="productWidth">Largura (cm)</label>
                        <input id="productWidth" name="productWidth" type="text" class="form-control" v-model="product.dimensions.width" v-money="money" />
                      </div>
                    </div>

                    <div class="col-sm-3">
                      <div class="form-group">
                        <label for="productHeight">Altura (cm)</label>
                        <input id="productHeight" name="productHeight" type="text" class="form-control" v-model="product.dimensions.height" v-money="money" />
                      </div>
                    </div>

                    <div class="col-sm-3">
                      <div class="form-group">
                        <label for="productLength">Comprimento (cm)</label>
                        <input id="productLength" name="productLength" type="text" class="form-control" v-model="product.dimensions.length" v-money="money" />
                      </div>
                    </div>

                    <div class="col-sm-3">
                      <div class="form-group">
                        <label for="productWeight">Peso (kg)</label>
                        <input id="productWeight" name="productWeight" type="text" class="form-control" v-model="product.dimensions.weight" v-money="money" />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div class="card">
              <div class="card-body">
                <h4 class="card-title mb-3">Unidade de Venda</h4>
                <!-- <p class="card-title-desc">Preencha os dados</p> -->
                <form>
                  <div class="row">
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label for="productQuantityLimitPerSale">Qtd. Máxima por Pedido</label>
                        <input id="productQuantityLimitPerSale" name="productQuantityLimitPerSale" type="tel" class="form-control" v-model="product.quantity_limit_per_sale" />
                      </div>
                    </div>

                    <div class="col-sm-3">
                      <div class="form-group">
                        <label for="productUnitSale">Qtd. Venda</label>
                        <input id="productUnitSale" name="productUnitSale" type="tel" class="form-control" v-model="product.unit_sale" v-money="money" />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div class="row mt-4 align-items-center">
              <div class="col-sm-6">
                <router-link
                  tag="a"
                  to="/products"
                  class="btn text-muted d-none d-sm-inline-block btn-link"
                >
                  <i class="mdi mdi-arrow-left mr-1"></i> Voltar para lista de produtos
                </router-link>
              </div>

              <div class="col-sm-6">
                <div class="text-sm-right">
                  <!-- <b-spinner class="m-2" variant="primary" role="status" v-if="loading"></b-spinner> -->
                  <button type="button" class="btn btn-primary btn-rounded mb-2 mr-2" @click="saveDimensions">
                    <i class="mdi mdi-check mr-1"></i> Salvar Informações
                  </button>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>

        <b-tab :disabled="!product._id ? true : false">
          <template v-slot:title>
            <i class="bx bx-add-to-queue d-block check-nav-icon mt-4 mb-2"></i>
            <p class="font-weight-bold mb-4">Variações</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <!-- <h4 class="card-title">Dados do Produto</h4>
                <p class="card-title-desc">Preencha os dados</p> -->
                <form>
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="form-group">
                        <div class="custom-control custom-checkbox mb-3">
                          <input type="checkbox" class="custom-control-input" id="variation_by_association" :disabled="product.need_select_variation" v-model="product.variation_by_association" />
                          <label class="custom-control-label card-title" for="variation_by_association">Produto com variação por associação</label>
                          <p class="card-title-desc">Aqui você associa produtos já cadastrados como variação. Dessa forma, cada produto possui o seu cadastro individual.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div v-if="product.variation_by_association">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="form-group">
                          <div class="custom-control custom-checkbox mb-3">
                            <input type="checkbox" class="custom-control-input" id="is_main_variation" v-model="product.is_main_variation" />
                            <label class="custom-control-label" for="is_main_variation">Esse é o produto-pai</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-sm-5" v-if="product.is_main_variation">
                        <div class="form-group">
                          <label for="productVariationTitle">Título da Variação</label>
                          <input id="productVariationTitle" name="productVariationTitle" type="text" class="form-control" placeholder="Ex.: Selecione a variação do produto" v-model="product.variation_title" />
                        </div>
                      </div>

                      <div class="col-sm-3">
                        <div class="form-group">
                          <label for="productVariationDescription">Descrição da Variação</label>
                          <input id="productVariationDescription" name="productVariationDescription" type="text" class="form-control" placeholder="Ex.: P, 42, branco, etc." v-model="product.variation_description" />
                        </div>
                      </div>
                    </div>

                    <div class="row" v-if="!product.is_main_variation">
                      <div class="col-sm-8">
                        <div class="form-group">
                          <label class="control-label">Produto Pai</label>
                          <!-- <multiselect
                            v-model="product.category"
                            :options="categories"
                            placeholder="Selecione uma opção"
                            label="description"
                            track-by="_id"
                            selectLabel="Enter para selecionar"
                            selectedLabel="Selecionado"
                            deselectLabel="Enter para remover"
                          ></multiselect> -->

                          <multiselect
                            v-model="product.main_product"
                            :options="productsToVariation"
                            :loading="isLoadingProducts"
                            :closeOnSelect="true"
                            @search-change="findProductsToVariationConfig"
                            placeholder="Selecione uma opção"
                            label="fullDescription"
                            track-by="_id"
                            selectLabel="Enter para selecionar"
                            selectedLabel="Selecionado"
                            deselectLabel="Enter para remover"
                          ></multiselect>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div class="card">
              <div class="card-body">
                <!-- <h4 class="card-title">Dados do Produto</h4>
                <p class="card-title-desc">Preencha os dados</p> -->
                <form>
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="form-group">
                        <div class="custom-control custom-checkbox mb-3">
                          <input type="checkbox" class="custom-control-input" id="need_select_variation" :disabled="product.variation_by_association" v-model="product.need_select_variation" />
                          <label class="custom-control-label card-title" for="need_select_variation">Produto com variação simples</label>
                          <p class="card-title-desc">Aqui você pode definir as variações do seu produto sem precisar cadastrar novos produtos (por exemplo: tamanho, cor, modelo). É possível definir preço e estoque individualmente para cada variação.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div v-if="product.need_select_variation">
                    <div class="row">
                      <div class="col-sm-5">
                        <div class="form-group">
                          <label for="productVariationTitle">Título da Variação</label>
                          <input id="productVariationTitle" name="productVariationTitle" type="text" class="form-control" placeholder="Ex.: Selecione a variação do produto" v-model="product.variation_title" />
                        </div>
                      </div>
                    </div>
                    
                    <div class="row">
                      <div class="col-sm-2">
                        <div class="form-group">
                          <label for="productVariationSku">Cód. SKU</label>
                          <input id="productVariationSku" name="productVariationSku" type="text" class="form-control" v-model="product.sku" disabled/>
                        </div>
                      </div>

                      <div class="col-sm-3">
                        <div class="form-group">
                          <label for="productVariationDescription">Descrição</label>
                          <input id="productVariationDescription" name="productVariationDescription" type="text" class="form-control" placeholder="Ex.: P, 42, branco, etc." v-model="product.variation_description" />
                        </div>
                      </div>

                      <div class="col-sm-3">
                        <div class="form-group">
                          <label for="productPrice">Preço</label>

                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span id="validationTooltipUsernamePrepend" class="input-group-text">R$</span>
                            </div>
                            <input
                              id="productPrice"
                              name="productPrice"
                              class="form-control"
                              v-model="product.original_price"
                              v-money="money"
                              disabled
                            />
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-2">
                        <div class="form-group">
                          <label for="productStock">Estoque</label>

                          <input
                            id="productStock"
                            name="productStock"
                            type="tel"
                            class="form-control"
                            v-model="product.stock"
                            disabled
                          />
                        </div>
                      </div>
                    </div>

                    <div class="row" v-for="(variation, index) in product.variations" :key="index">
                      <div class="col-sm-2">
                        <div class="form-group">
                          <label :for="'variationSKU' + index">Cód. SKU</label>
                          <input :id="'variationSKU' + index" type="text" class="form-control" v-model="variation.sku" />
                        </div>
                      </div>

                      <div class="col-sm-3">
                        <div class="form-group">
                          <label :for="'variationDescription' + index">Descrição</label>
                          <input :id="'variationDescription' + index" type="text" class="form-control" placeholder="P, 42, pequeno, etc." v-model="variation.variation_description" />
                        </div>
                      </div>

                      <div class="col-sm-3">
                        <div class="form-group">
                          <label :for="'variationPrice' + index">Preço</label>

                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span id="validationTooltipUsernamePrepend" class="input-group-text">R$</span>
                            </div>
                            <input
                              id="'variationPrice' + index"
                              class="form-control"
                              v-model="variation.price"
                              v-money="money"
                            />
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-2">
                        <div class="form-group">
                          <label for="productStock">Estoque</label>

                          <input
                            id="variationStock"
                            name="variationStock"
                            type="tel"
                            class="form-control"
                            v-model="variation.stock"
                          />
                        </div>
                      </div>

                      <div class="col-sm-1 mt-3 align-self-center">
                        <a class="action-icon text-danger" @click="removeVariation(index)">
                          <i class="mdi mdi-trash-can font-size-18"></i>
                        </a>
                      </div>
                    </div>

                    <div class="row mt-2">
                      <div class="col-sm-10">
                        <div class="text-right">
                          <b-button pill variant="outline-primary" @click="addVariation">+ Nova Variação</b-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div class="card">
              <div class="card-body">
                <form>
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="form-group">
                        <div class="custom-control custom-checkbox mb-3">
                          <input type="checkbox" class="custom-control-input" id="fractionated_variation" v-model="product.fractionated_variation" />
                          <label class="custom-control-label card-title" for="fractionated_variation">Utilizar variação fracionada?</label>
                          <p class="card-title-desc">Marque essa opção se deseja vender o produto principal de forma fracionada, definindo a fração desejada.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div v-if="product.fractionated_variation">
                    <div class="row">
                      <div class="col-sm-3">
                        <div class="form-group">
                          <label for="productStock">Fração para Venda</label>

                          <input
                            id="fractionated_unit"
                            name="fractionated_unit"
                            type="tel"
                            class="form-control"
                            v-model="product.fractionated_unit"
                          />

                          <div class="custom-control custom-checkbox mt-3 mb-0">
                            <input type="checkbox" class="custom-control-input" id="fractionated_as_box" v-model="product.fractionated_as_box" />
                            <label class="custom-control-label" for="fractionated_as_box">Vender como caixa</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div class="card">
              <div class="card-body">
                <h4 class="card-title mb-1">Grupos de Complementos</h4>
                <p class="card-title-desc mb-3">Selecione os grupos de complementos que podem ser incluídos no produto</p>
                <form>
                  <div class="row">
                    <div class="col-sm-8">
                      <div class="form-group">
                        <!-- <label for="productQuantityLimitPerSale">Qtd. Máxima por Pedido</label> -->
                        <multiselect
                          v-model="product.complements"
                          :options="complements"
                          :multiple="true"
                          placeholder="Selecione várias opções"
                          label="description"
                          track-by="_id"
                          selectLabel="Enter para selecionar"
                          selectedLabel="Selecionado"
                          deselectLabel="Enter para remover"
                        ></multiselect>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div class="row mt-4 align-items-center">
              <div class="col-sm-6">
                <router-link
                  tag="a"
                  to="/products"
                  class="btn text-muted d-none d-sm-inline-block btn-link"
                >
                  <i class="mdi mdi-arrow-left mr-1"></i> Voltar para lista de produtos
                </router-link>
              </div>

              <div class="col-sm-6">
                <div class="text-sm-right">
                  <button type="button" class="btn btn-primary btn-rounded mb-2 mr-2" @click="saveVariations">
                    <i class="mdi mdi-check mr-1"></i> Salvar Variações
                  </button>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>

        <b-tab :disabled="!product._id ? true : false">
          <template v-slot:title>
            <i class="bx bx-cog d-block check-nav-icon mt-4 mb-2"></i>
            <p class="font-weight-bold mb-4">Parametrização</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">Configurações de Exibição</h4>
                <p class="card-title-desc">Define as características de exibição do produto em algumas telas específicas</p>
                
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <div class="custom-control custom-checkbox mb-3">
                        <input type="checkbox" class="custom-control-input" id="featured" v-model="product.featured" />
                        <label class="custom-control-label" for="featured">Destaque</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <div class="custom-control custom-checkbox mb-3">
                        <input type="checkbox" class="custom-control-input" id="release" v-model="product.release" />
                        <label class="custom-control-label" for="release">Lançamento</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card">
              <div class="card-body">
                <h4 class="card-title">Configurações Gerais</h4>
                <p class="card-title-desc">Defina aqui algumas características gerais do produto</p>
                
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <div class="custom-control custom-checkbox mb-3">
                        <input type="checkbox" class="custom-control-input" id="check_stock" v-model="product.check_stock" />
                        <label class="custom-control-label" for="check_stock">Produto com controle de estoque?</label>
                      </div>

                      <div class="custom-control custom-checkbox mb-3">
                        <input type="checkbox" class="custom-control-input" id="use_as_complement" v-model="product.use_as_complement" />
                        <label class="custom-control-label" for="use_as_complement">Disponibilizar também como adicional</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-4 align-items-center">
              <div class="col-sm-6">
                <router-link
                  tag="a"
                  to="/products"
                  class="btn text-muted d-none d-sm-inline-block btn-link"
                >
                  <i class="mdi mdi-arrow-left mr-1"></i> Voltar para lista de produtos
                </router-link>
              </div>

              <div class="col-sm-6">
                <div class="text-sm-right">
                  <!-- <b-spinner class="m-2" variant="primary" role="status" v-if="loading"></b-spinner> -->
                  <button type="button" class="btn btn-primary btn-rounded mb-2 mr-2" @click="saveSettings">
                    <i class="mdi mdi-check mr-1"></i> Salvar Informações
                  </button>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>
      </b-tabs>
    </div>

    <b-modal id="modal-remove-image" title="Excluir Imagem" title-class="font-18" centered>
      <p>Confirma a exclusão da imagem selecionada?</p>

      <div slot="modal-footer">
        <b-btn variant="link" @click="$bvModal.hide('modal-remove-image')">Cancelar</b-btn>
        <b-btn variant="primary" @click="removeImage">Excluir</b-btn>
      </div>
    </b-modal>

    <b-modal id="modal-remove-variation" title="Excluir Variação" title-class="font-18" centered>
      <p>Confirma a exclusão da variação selecionada? Ela será removida definitivamente.</p>

      <div slot="modal-footer">
        <b-btn variant="link" @click="$bvModal.hide('modal-remove-variation')">Cancelar</b-btn>
        <b-btn variant="primary" @click="removeProductVariation">Excluir</b-btn>
      </div>
    </b-modal>
  </Layout>
</template>

<style lang="scss">
  .images {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;

    .image {
      display: flex;
      flex-direction: row;
      align-items: center;

      .image-group {
        flex-direction: column;
        display: flex;
      }
    }

    img {
      height: 140px;
      margin: 20px 20px 10px 20px;
      min-height: 80px;
    }

    .new-image {
      // border: 2px dashed #a6b0cf !important;
      height: 140px;
      width: 140px;
      border-radius: 6px;
      color: #a6b0cf;
      // font-size: 30px;
      justify-content: center;
      flex-direction: column;
      display: flex;
      align-items: center;
      // padding: 10px;

      p {
        font-size: 10px;
        text-align: center;
        margin: 6px 0px 0px 0px;
      }

      // margin: 20px;
    }

    input[type="file"] {
      display: none;
    }
  }

  .nav-link.disabled {
    color: #e1e1e1;
  }
</style>